// DESIGNER — 15 tools in 4 blocks. Marker positions are card millimetres (mx from the face's left
// edge, my from its top); est:true = my authored guess, replaced the moment a mark is placed.
// hom: photo% -> card fraction per face. A was locked onto the real engraving (0.90 agreement);
// B is a hand-held shot at a steep angle with fingers over two corners, so its fit is approximate —
// place face-B marks in the 3D view, not on the photo.
// ph: a photo-only position (percent of that face's shot) for a face whose photo cannot be
// fitted to millimetres — it moves the chip on the photo and never the marker in 3D.
window.DSN = {
 "hom": {
  "A": [[0.01162447, 0.00143706, -0.1140453], [0.00074559, 0.02038036, -0.4008245], [-0.00033601, 0.00400375, 1]],
  "B": [[-0.00076695, 0.01275632, -0.00655675], [-0.01884644, 0.00941632, 0.99730427], [-0.00512786, 0.0041717, 1]]
 },
 "photo": {
  "A": "https://mrf.tools/cdn/shop/files/mrf26-dsn-photo-a.jpg?v=b3",
  "B": "https://mrf.tools/cdn/shop/files/mrf26-dsn-photo-b.jpg?v=b3"
 },
 // a face flagged here refuses mm placement on its photo; its chips come from ph instead
 "homApprox": {
  "B": true
 },
 "blocks": [
  {
   "name": "Rulers & scales",
   "tools": [
    {
     "n": 1,
     "cat": "MEASURE",
     "side": "A",
     "mx": 45.9,
     "my": 54,
     "est": false,
     "name": "Inch ruler",
     "desc": "3\" scale along the top edge in halves, quarters and eighths, ticks cut through the edge so you read against the work instead of beside it.",
     "sc": "Checking a print at 1:1 before it goes to the plotter."
    },
    {
     "n": 6,
     "cat": "MEASURE",
     "side": "B",
     "mx": 43,
     "my": 3,
     "est": true,
     "name": "Metric ruler",
     "desc": "80 mm along the back edge, millimetre ticks with every tenth numbered — the side you actually work in.",
     "sc": "Sizing a mount board margin at the framing counter.",
     "ph": {
      "B": {
       "x": 75,
       "y": 39.1
      }
     }
    },
    {
     "n": 4,
     "cat": "TYPE",
     "side": "A",
     "mx": 11.3,
     "my": 46.1,
     "est": false,
     "name": "Pica scale",
     "desc": "Typographic picas along the bottom-left edge: 15, 12, 9, 6, 3 — the unit type is still set in.",
     "sc": "Reading a legacy spec sheet that quotes leading in picas."
    },
    {
     "n": 9,
     "cat": "TYPE",
     "side": "B",
     "mx": 77,
     "my": 51,
     "est": true,
     "name": "Pixel scale",
     "desc": "PPI 350 and 150 rulers: hold the card to a printed proof and read pixel dimensions straight off it.",
     "sc": "Deciding whether a placed image will hold up at print size.",
     "ph": {
      "B": {
       "x": 39.6,
       "y": 78.8
      }
     }
    }
   ]
  },
  {
   "name": "Angles",
   "tools": [
    {
     "n": 3,
     "cat": "ANGLE",
     "side": "A",
     "mx": 22,
     "my": 14,
     "est": true,
     "name": "Protractor",
     "desc": "Full 0–180° arc round the circle template, numbered every 10° with 1° ticks on the outer ring.",
     "sc": "Transferring an angle off a site sketch onto the drawing."
    },
    {
     "n": 5,
     "cat": "ANGLE",
     "side": "A",
     "mx": 2,
     "my": 49.1,
     "est": false,
     "name": "Precision protractor",
     "desc": "The narrow slotted arc at the edge: a pencil tip rides the slot, so the angle is drawn, not just read.",
     "sc": "Stepping out a repeating angle without re-setting the card."
    },
    {
     "n": 13,
     "cat": "ANGLE",
     "side": "B",
     "mx": 68.8,
     "my": 4.2,
     "est": false,
     "name": "Radian protractor",
     "desc": "Marked 57.3° — one radian — with the radian ladder along the arc, for anyone whose maths is in rad.",
     "sc": "Sanity-checking a rotation value from code against paper.",
     "ph": {
      "B": {
       "x": 73.6,
       "y": 54.9
      }
     }
    },
    {
     "n": 2,
     "cat": "ANGLE",
     "side": "A",
     "mx": 33,
     "my": 0.5,
     "est": false,
     "name": "Quick angle 30° · 45° · 60°",
     "desc": "Three engraved reference lines for the angles worth having by feel, so the card replaces a set square for a quick mark.",
     "sc": "Ruling a 45° crop line straight onto a print."
    }
   ]
  },
  {
   "name": "Squares & templates",
   "tools": [
    {
     "n": 11,
     "cat": "DRAW",
     "side": "A",
     "mx": 83.6,
     "my": 23.6,
     "est": false,
     "name": "Inch L-square",
     "desc": "The right edge carries a perpendicular inch scale: two edges at a true 90° make the card a small try square.",
     "sc": "Squaring a mat cut on a cutting mat with no rule to hand."
    },
    {
     "n": 8,
     "cat": "DRAW",
     "side": "B",
     "mx": 0,
     "my": 54,
     "est": false,
     "name": "Metric L-square",
     "desc": "Same corner in millimetres — 0 at the corner, so you measure and square in one move.",
     "sc": "Marking a 20 mm border on a sheet, square to the edge.",
     "ph": {
      "B": {
       "x": 9.8,
       "y": 12.7
      }
     }
    },
    {
     "n": 10,
     "cat": "DRAW",
     "side": "A",
     "mx": 43.3,
     "my": 19.2,
     "est": false,
     "name": "Circle template",
     "desc": "Five drawn circles — ø1/4\" to ø1/2\" on the imperial face, ø6 to ø12 mm on the metric one — each labelled at its edge.",
     "sc": "Rounding a corner radius by hand, twice the same size."
    },
    {
     "n": 15,
     "cat": "DRAW",
     "side": "B",
     "mx": 60,
     "my": 52,
     "est": true,
     "name": "Quick parallel lines",
     "desc": "Edge notches at fixed spacing: run a pencil in a notch, slide the card along a straightedge and the lines come out parallel.",
     "sc": "Ruling guide lines for hand lettering without a T-square.",
     "ph": {
      "B": {
       "x": 22.4,
       "y": 60.9
      }
     }
    }
   ]
  },
  {
   "name": "Compass & desk",
   "tools": [
    {
     "n": 12,
     "cat": "DRAW",
     "side": "A",
     "mx": 79.1,
     "my": 47,
     "est": false,
     "name": "Inch compass",
     "desc": "Pivot hole plus the radius holes down the ruler: pin the pivot, put the pencil in a hole and swing a circle in inches.",
     "sc": "Striking a 2\" arc with no compass in the bag."
    },
    {
     "n": 7,
     "cat": "DRAW",
     "side": "B",
     "mx": 1.3,
     "my": 1.7,
     "est": false,
     "name": "Metric compass",
     "desc": "The same trick in millimetres, holes spaced so the common radii come up without arithmetic.",
     "sc": "Drawing a ø60 mm circle on a layout sheet.",
     "ph": {
      "B": {
       "x": 51.3,
       "y": 5.7
      }
     }
    },
    {
     "n": 14,
     "cat": "DESK",
     "side": "B",
     "mx": 43,
     "my": 45,
     "est": true,
     "name": "Phone stand",
     "desc": "The long slot takes a phone's edge and holds it at reading angle — the card props your reference while you draw.",
     "sc": "Keeping a reference photo upright next to the sketchbook.",
     "ph": {
      "B": {
       "x": 31.6,
       "y": 57.1
      }
     }
    }
   ]
  }
 ]
};
